import AnnouncementBanner from "@/landing-page/general-care/AnnouncementBanner";

type Props = { waitTimeCopy: string };

export default function WaitTimeBanner({ waitTimeCopy }: Props) {
  return (
    <AnnouncementBanner
      message={`We're experiencing higher-than-usual demand today. ${waitTimeCopy}.`}
    />
  );
}
